import 
    React
from 'react';
import { 
    useSelector 
} from 'react-redux';
import {
    MarkerF,
} from '@react-google-maps/api';

// Constans
// import { MARKERS_INDEX } from '../assets'
import { VEHICLE_TRANSIT_STATUS_COLOR } from '../../../../../v3/constants/template/status';

const VehicleMarkers = (props) => {
    const { vid } = props;

    // Redux Store
    const vehicles = useSelector(state => state.containers.v3.vehicles);

    // const getVehicleTransitColor = () => {

    //     const transitStatus = thisVehicle.transitStatus || null
        
    //     return (transitStatus && VEHICLE_TRANSIT_STATUS_COLOR[transitStatus]) || VEHICLE_TRANSIT_STATUS_COLOR[null];
    // }

    const getVehicleMarker = (thisVehicle) => {
        if (
            thisVehicle &&
            thisVehicle.location
        ) {
            const vid = thisVehicle.vid;

            return (
                <MarkerF
                    key = {vid}
                    // icon = { MARKERS_INDEX[thisVehicle.transitStatus] }
                    icon = {{
                        path: window.google && window.google.maps && window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                        scale: 5,
                        strokeColor: (thisVehicle.transitStatus && VEHICLE_TRANSIT_STATUS_COLOR[thisVehicle.transitStatus]) || VEHICLE_TRANSIT_STATUS_COLOR[null],
                        rotation: Number(thisVehicle.heading),
                        fillOpacity: 1,

                        // 24 is sprite width and 28 is sprite height. Make sure to match future anchors accordingly
                        // anchor: new window.google.maps.Point(24 / 2, 28 / 2),
                    }}
                    position = {{
                        lat: parseFloat(thisVehicle.location.lat),
                        lng: parseFloat(thisVehicle.location.lon)
                    }}
                    onClick = {() => {
                    }}
                >
                </MarkerF>
            )
        }
    }

    const thisVehicle = {...vehicles.stateByID[vid], ...vehicles.derivativeStateByID[vid]};

    return getVehicleMarker(thisVehicle)
}

export default React.memo(VehicleMarkers)